// source-app.model.ts

export enum SourceAppEnum {
  PAP = 'pap',
  PARENTS_APP = 'parents-app'
}
